/* Build your own 3-ball bundle (sections/g3d-build-bundle.liquid). Balls, variants, prices, stock and photos come from #bb-data; the $7 is the
   Shopify code BUILD3, which only this page applies. Add to cart fires CartLinesUpdateEvent like the theme's own forms, so the header bubble and cart drawer refresh. */
import { addToCart } from '@theme/g3d-cart';
import { formatMoney } from '@theme/money-formatting';

(() => {
  const root = document.getElementById('bb-root');
  const $ = id => document.getElementById(id);
  // the code discount "Build Your Own: $7 off any 3" (code BUILD3): $7 off, min 3 from Bundle Eligible (cents; the copy says $7 too).
  // Only this page applies it (owner, 2026-10-25), so 3 balls added anywhere else pay full price
  // ponytail: the store sells in USD only; a second currency would need the discount's converted amount here
  const OFF = 700, CODE = 'BUILD3';
  // the store's discounts each apply once per order and never together: once the cart holds
  // any one, a new box gets no $7. Read from /cart.js on load and after each add
  // ponytail: a ball removed in the cart drawer is re-read only on the next add or reload (the tray then shows too high, never too low)
  let used = false;
  // sets the cart's whole code list, the way Horizon's own discount form does (assets/cart-discount.js)
  const setCodes = codes => fetch(Theme.routes.cart_update_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) })
    .then(r => r.ok ? r.json() : Promise.reject(new Error('discount code: HTTP ' + r.status)));
  const DATA = JSON.parse($('bb-data').textContent);
  // one row per ball, as the mockup had them: v = the 70mm Non-Clicker variants (the section drops Clicker and 100mm; all of them when there's no Function option):
  // [id, shiny, extra option value, cents, available]; t / g = types and tags; f / s = front and shiny-front photos; pf / psf = a poncho's front / shiny front per Eeveelution; x = the extra option's name
  const ROWS = DATA.balls.map(b => {
    const si = b.o.indexOf('Style'), fi = b.o.indexOf('Function'), xi = b.o.findIndex(n => n !== 'Style' && n !== 'Function' && n !== 'Size');
    return { h: b.h, n: b.n.replace(/ Ball$/, ''), num: b.num, t: (b.t || []).join(' '), g: b.tags.join(' '), f: b.f, s: b.s || '', pf: b.pf, psf: b.psf, x: xi < 0 ? '' : b.o[xi],
      v: b.v.filter(v => fi < 0 || v[1][fi] === 'Non-Clicker').map(v => [v[0], v[1][si] === 'Shiny' ? 1 : 0, xi < 0 ? '' : v[1][xi], v[2], v[3] ? 1 : 0]) };
  }).filter(r => r.v.length);
  const TYPE_C = { Normal: '#8f99a1', Fighting: '#ce3f6b', Flying: '#92aade', Poison: '#ab6ac9', Ground: '#da7747', Rock: '#c8b78a', Bug: '#91c02c', Ghost: '#5369ad', Steel: '#5b8fa2',
    Fire: '#fc9c53', Water: '#4d90d6', Grass: '#66bc5f', Electric: '#f4d23b', Psychic: '#f97077', Ice: '#73cebf', Dragon: '#096dc3', Dark: '#5b5265', Fairy: '#ec90e8' };
  const REGIONS = [['Kanto', 151], ['Johto', 251], ['Hoenn', 386], ['Sinnoh', 493], ['Unova', 649], ['Kalos', 721], ['Alola', 809], ['Galar', 905], ['Paldea', 1025], ['Winds & Waves', 0]];
  const GROUPS = [['starter', 'Starters'], ['legendary', 'Legendaries'], ['mythical', 'Mythicals'], ['eeveelution', 'Eeveelutions'], ['spooky', 'Spooky'], ['forms', 'Mega & Shadow'], ['poncho', 'Ponchos'], ['shinyphoto', 'Shiny photo']];
  const OPT_LABEL = { Eeveelution: 'Poncho', Type: 'Version', Form: 'Form' };
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = c => formatMoney(c, DATA.moneyFormat || '${{amount}}', DATA.currency || 'USD'); // as Liquid's | money
  const img = (url, w) => url.replace(/width=\d+/, 'width=' + w); // the section hands out 1000px image URLs
  const pad = n => String(n).padStart(3, '0');
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const plural = (n, w) => n + ' ' + w + (n === 1 ? '' : 's');
  const replay = (el, cls) => { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); };
  const list = a => a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a.at(-1);
  // readable text on a type colour: white or ink, whichever has the higher contrast
  const lum = hex => [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16) / 255).map(c => c <= .04045 ? c / 12.92 : ((c + .055) / 1.055) ** 2.4).reduce((s, c, i) => s + c * [.2126, .7152, .0722][i], 0);
  const onC = hex => 1.05 / (lum(hex) + .05) >= (lum(hex) + .05) / (lum('#16161a') + .05) ? '#fff' : '#16161a';
  const typePill = t => TYPE_C[t] ? `<span class="bb-type" style="--c:${TYPE_C[t]};--on:${onC(TYPE_C[t])}"><svg aria-hidden="true"><use href="#bb-t-${t}"/></svg>${t}</span>` : '<span class="bb-type bb-type--unk">???</span>';

  const P = ROWS.map(r => {
    const types = r.t ? r.t.split(' ') : [], groups = r.g ? r.g.split(' ') : [], known = types.filter(t => TYPE_C[t]);
    const m = r.n.match(/^(\w+) - (.*Poncho)$/); // "Pikachu - Eeveelutions Poncho" -> Pikachu / Eeveelutions Poncho
    const p = { ...r, types, title: m ? m[1] : r.n, sub: m ? m[2] : '', form: (r.n.match(/^(Mega|Shadow) /) || [])[1] || '',
      c: TYPE_C[known[0]] || '#8b8d98', c2: TYPE_C[known[1]] || TYPE_C[known[0]] || '#8b8d98',
      region: r.num == null ? (/\bwinds-and-waves\b/.test(r.g) ? REGIONS.length - 1 : -1) : REGIONS.findIndex(([, hi]) => !hi || r.num <= hi), sh: 0 };
    p.xs = r.x ? [...new Set(r.v.map(v => v[2]))] : [''];
    p.xv = (r.v.find(v => v[4]) || r.v[0])[2]; // default: the store's first in-stock version (as today's picker)
    p.inG = id => id === 'forms' ? !!p.form : id === 'poncho' ? /Poncho/.test(r.n) : id === 'shinyphoto' ? !!(r.s || r.psf) : groups.includes(id);
    p.hay = [r.n, 'no.' + pad(r.num ?? 0), String(r.num ?? ''), ...types, (REGIONS[p.region] || [''])[0], ...GROUPS.filter(([id]) => id !== 'forms' && id !== 'shinyphoto' && p.inG(id)).flat(), p.v.some(v => v[1]) ? 'shiny' : ''].join(' ').toLowerCase();
    return p;
  }).sort((a, b) => (a.num ?? 1e4) - (b.num ?? 1e4) || !!a.form - !!b.form || a.n.localeCompare(b.n));
  P.forEach((p, i) => p.i = i);
  const variant = (p, sh = p.sh, x = p.xv) => p.v.find(v => v[1] === sh && v[2] === x);
  const pickable = p => p.v.some(v => v[4]);
  // the photo for the chosen version: the shiny photo where one exists (Haxorus's only photo is its shiny print)
  const photo = p => (p.sh && (p.psf?.[p.xv] || p.s)) || p.pf?.[p.xv] || p.f;

  let picks = []; // product indices, in pick order
  const grid = $('bb-grid'), tray = $('bb-tray'), box = $('bb-box');
  // no balls at all (a wrong or empty collection setting): the section's #bb-none says so instead of "no balls match"
  if (!P.length) { root.classList.add('is-none'); $('bb-none').hidden = false; }

  // the cards (without the script the section lists the balls as plain links)
  const optHTML = p => p.x ? `<label class="bb-opt"><span>${OPT_LABEL[p.x] || p.x}</span><select data-i="${p.i}" aria-label="${esc(p.title)}: ${OPT_LABEL[p.x] || p.x}">${p.xs.map(x => `<option value="${esc(x)}">${esc(x.replace('Poncho - ', 'Poncho, '))}</option>`).join('')}</select></label>` : '';
  grid.innerHTML = P.map(p => `<li><div class="bb-card" data-i="${p.i}" style="--c:${p.c};--c2:${p.c2}">
    <i class="bb-foil" aria-hidden="true"></i>
    <button type="button" class="bb-card__pick" aria-pressed="false"></button>
    <span class="bb-card__top"><b>${esc(p.title)}</b><span>${p.num == null ? 'No.???' : 'No.' + pad(p.num)}</span></span>
    <span class="bb-card__ph"><img src="${img(p.f, 360)}" alt="" loading="lazy" decoding="async" width="360" height="360"><span class="bb-card__tag"${p.form ? '' : ' hidden'}>${p.form}</span><span class="bb-card__note" hidden></span><i class="bb-sweep" aria-hidden="true"></i><button type="button" class="bb-card__sh" aria-pressed="false" aria-label="Shiny ${esc(p.title)}"><i aria-hidden="true">✦</i>Shiny</button></span>
    ${p.sub ? `<span class="bb-card__sub">${esc(p.sub)}</span>` : ''}
    <span class="bb-types">${p.types.map(typePill).join('')}</span>
    ${optHTML(p)}
    <span class="bb-card__foot"><span class="bb-card__cost"></span><span class="bb-card__add" aria-hidden="true"></span></span>
  </div></li>`).join('');
  const cards = [...grid.querySelectorAll('.bb-card')];
  const cardOf = p => cards[p.i];

  // one card's look: shiny, photo + honest photo note, price, stock, picked. ariaOnly: just what a screen reader hears
  // (a Shiny flip says it at once; the look follows when the card is edge-on)
  function paint(p, ariaOnly) {
    const c = cardOf(p), v = variant(p), k = picks.indexOf(p.i), out = !v || !v[4], shOk = !!(variant(p, 1) || [])[4], f = photo(p), gold = f === p.s || f === p.psf?.[p.xv];
    const sh = c.querySelector('.bb-card__sh'), pick = c.querySelector('.bb-card__pick');
    sh.setAttribute('aria-pressed', !!p.sh);
    pick.setAttribute('aria-pressed', k > -1);
    pick.setAttribute('aria-disabled', out);
    pick.setAttribute('aria-label', `Pick ${p.sh ? 'Shiny ' : ''}${p.n}${p.x ? ', ' + p.xv : ''}, ${p.num == null ? 'number unknown' : 'No.' + pad(p.num)}, ${money((v || p.v[0])[3])}${out ? ', sold out' : ''}`);
    if (ariaOnly || c.pend) return; // a card turning to edge-on keeps its old face; its swap paints it
    const im = c.querySelector('.bb-card__ph img'), src = img(f, 360);
    if (im.getAttribute('src') !== src) im.src = src;
    c.classList.toggle('is-shiny', !!p.sh);
    c.classList.toggle('is-out', out);
    c.classList.toggle('is-picked', k > -1);
    // a note wherever the photo doesn't show what you'd get
    const note = out ? 'Sold out' : gold ? '✦ Shiny photo' : p.sh ? 'Normal photo' : p.x === 'Form' && p.xv !== 'Battle Bond' ? 'Photo: Battle Bond' : p.x === 'Eeveelution' && !p.n.startsWith('Pikachu') && !p.pf?.[p.xv] ? 'Photo soon' : p.x === 'Eeveelution' && !p.pf?.[p.xv] && p.xv !== 'Umbreon' ? 'Photo: Umbreon poncho' : '';
    const n = c.querySelector('.bb-card__note');
    n.textContent = note; n.hidden = !note; n.classList.toggle('is-gold', gold);
    c.querySelector('.bb-card__cost').textContent = money((v || p.v[0])[3]);
    c.querySelector('.bb-card__add').textContent = out ? 'Sold out' : k > -1 ? 'Ball ' + (k + 1) : picks.length === 3 ? 'Box full' : 'Pick';
    sh.disabled = !shOk && !p.sh;
    const sel = c.querySelector('select');
    if (sel) { sel.value = p.xv; [...sel.options].forEach(o => { const ok = (variant(p, p.sh, o.value) || [])[4]; o.disabled = !ok; o.textContent = o.value.replace('Poncho - ', 'Poncho, ') + (ok ? '' : ' (sold out)'); }); }
  }

  // the tray and the box on the bench
  const slotsEl = $('bb-slots'), balls = [...box.querySelectorAll('.bb-box__ball')], lines = [...box.querySelectorAll('.bb-slip__ln')], nests = [...box.querySelectorAll('.bb-box__cr')], outB = box.querySelector('.bb-box__out');
  // restart a class animation on an SVG part (replay's offsetWidth is undefined on SVG, so it would not restyle)
  const kick = (el, cls) => { el.classList.remove(cls); el.getBoundingClientRect(); el.classList.add(cls); };
  let hold = false; // the packed box is shut and leaving: it keeps its state; picks made meanwhile drop into the fresh box
  function renderTray(justIn) {
    const n = picks.length, sum = picks.reduce((s, i) => s + variant(P[i])[3], 0), full = n === 3, off = used ? 0 : OFF;
    slotsEl.innerHTML = [0, 1, 2].map(k => {
      const p = P[picks[k]];
      if (!p) return `<li class="is-empty"><span class="bb-slot"><span class="bb-slot__n">${k + 1}</span></span><span><b>Ball ${k + 1}</b><small>Empty</small></span></li>`;
      const v = variant(p);
      return `<li><button type="button" class="bb-slot${p.sh ? ' is-shiny' : ''}${k === justIn ? ' is-in' : ''}" data-i="${p.i}" aria-label="Take ${p.sh ? 'Shiny ' : ''}${esc(p.n)} out of your bundle"><img src="${img(photo(p), 360)}" alt="" width="360" height="360"><span class="bb-slot__x" aria-hidden="true">×</span></button>`
        + `<span><b>${p.sh ? '<i class="bb-star">✦</i> ' : ''}${esc(p.n)}</b><small>${money(v[3])}${p.x ? ' · ' + esc(p.xv.replace('Poncho - ', '')) : ''}</small></span></li>`;
    }).join('');
    $('bb-trayN').textContent = full ? 'Ready: 3 of 3' : `${n} of 3 picked`;
    $('bb-subL').textContent = plural(n, 'ball');
    $('bb-sub').textContent = money(sum);
    $('bb-offL').textContent = used ? 'Bundle discount: already in your cart' : full ? 'Bundle discount' : 'Bundle, at 3 balls';
    $('bb-off').textContent = (off ? '−' : '') + money(off);
    $('bb-total').textContent = money(full ? sum - off : sum);
    $('bb-math').classList.toggle('is-short', !full);
    const add = $('bb-add');
    if (!busy && !add.classList.contains('is-added')) { // "Adding…" stays until the store answers
      add.setAttribute('aria-disabled', !full);
      $('bb-addL').textContent = full ? 'Add 3 to cart' : `Pick ${3 - n} more`;
      $('bb-addS').textContent = full ? money(sum - off) + (used ? '' : ' · $7 off') : used ? 'Discount already in cart' : '$7 off at 3';
    }
    tray.classList.toggle('is-full', full);
    grid.classList.toggle('is-full', full);
    if (hold) return;
    // the box on the bench: cradle k holds the k-th pick (an SVG <image>), slip line k names it
    const was = balls.map(b => b.dataset.i), gone = was.findIndex(i => i && !picks.includes(+i)), anim = !REDUCED && !box.classList.contains('is-packing');
    if (gone > -1 && anim) { // the ball taken out lifts from its own cradle; the ones after it slide along
      outB.querySelector('image').setAttribute('href', balls[gone].querySelector('image').getAttribute('href'));
      outB.setAttribute('transform', `translate(${84 * gone} 0)`);
      outB.classList.toggle('is-shiny', balls[gone].classList.contains('is-shiny'));
      kick(outB, 'is-lift');
    }
    box.dataset.n = n;
    balls.forEach((b, k) => {
      const p = P[picks[k]], im = b.querySelector('image'), ln = lines[k], t = ln.querySelector('text'), i = p ? String(p.i) : '';
      const moved = gone > -1 && k >= gone && i && was[k + 1] === i, fresh = i && i !== was[k] && !moved;
      if (p) { const src = img(photo(p), 360); if (im.getAttribute('href') !== src) im.setAttribute('href', src); } // the card's size: cached already
      if (i !== was[k]) { b.classList.remove('is-drop', 'is-shift', 'is-twk'); ln.classList.remove('is-write'); }
      if (anim && moved) kick(b, 'is-shift');
      if (anim && fresh) { kick(b, 'is-drop'); kick(ln, 'is-write'); nests.forEach(c => { if (+c.dataset.k === k) kick(c, 'is-ruffle'); }); }
      if (anim && p && p.sh && (fresh || (i === was[k] && !b.classList.contains('is-shiny')))) kick(b, 'is-twk'); // a twinkle, not when it only moved
      b.dataset.i = i;
      b.classList.toggle('is-on', !!p);
      b.classList.toggle('is-shiny', !!(p && p.sh));
      ln.classList.toggle('is-on', !!p);
      t.firstChild.textContent = p && p.sh ? '✦ ' : '';
      t.lastChild.textContent = p ? p.title : '';
      t.removeAttribute('textLength');
      if (p && t.getComputedTextLength() > 104) t.setAttribute('textLength', 104); // long names squeeze to fit; a clip is the backstop
    });
  }
  const repaint = justIn => { P.forEach(p => paint(p)); renderTray(justIn); };
  // the bench's idle moves (printer feed, drop rings, sticker glint) pause while it is off screen. The default root clips
  // through every scroller (the theme's .page-wrapper from 990px up too) and keeps working across a resize; no rootMargin here
  if (window.IntersectionObserver) new IntersectionObserver(([e]) => box.classList.toggle('is-paused', !e.isIntersecting)).observe(box);
  // the page's motion switch (WCAG 2.2.2): .bb-still holds the backdrop and those idle moves in CSS; picking and packing still play
  const motion = $('bb-motion');
  if (motion && !REDUCED) {
    motion.hidden = false;
    motion.onclick = () => { motion.textContent = root.classList.toggle('bb-still') ? 'Play motion' : 'Pause motion'; };
  }

  // a polite note above the tray
  const note = $('bb-note'), noteT = $('bb-noteT'), swapBtn = $('bb-swap'), noteX = $('bb-noteX');
  let noteTimer, swapFor = null;
  function say(text, opts = {}) {
    clearTimeout(noteTimer);
    noteT.textContent = text;
    note.classList.toggle('is-ok', !!opts.ok);
    note.classList.add('is-on');
    swapBtn.inert = noteX.inert = false;
    swapFor = opts.swap ?? null;
    swapBtn.hidden = swapFor == null;
    if (swapFor != null) swapBtn.textContent = 'Swap out ' + P[picks[0]].title;
    noteTimer = setTimeout(hush, opts.ms || 5000);
  }
  // the faded note's buttons go inert (out of the Tab order); focus inside it moves on to the add button first
  function hush() { clearTimeout(noteTimer); if (note.contains(document.activeElement)) $('bb-add').focus(); note.classList.remove('is-on'); swapFor = null; swapBtn.inert = noteX.inert = true; }
  noteX.onclick = hush;
  swapBtn.onclick = () => { if (swapFor == null) return; const p = P[swapFor]; if (picks.length === 3) picks.shift(); hush(); picks.push(p.i); repaint(picks.length - 1); fly(p); };

  function toggle(p) {
    const k = picks.indexOf(p.i);
    if (k > -1) { picks.splice(k, 1); hush(); repaint(); return; }
    const v = variant(p);
    if (!v || !v[4]) return say(`${p.sh ? 'Shiny ' : ''}${p.n} is sold out right now${pickable(p) && !p.sh ? '. Its Shiny version is in stock' : ''}.`);
    if (picks.length === 3) return say(`Your box holds 3. Take one out first, or swap your oldest pick for ${p.title}.`, { swap: p.i, ms: 8000 });
    picks.push(p.i);
    hush();
    repaint(picks.length - 1);
    fly(p);
    if (picks.length === 3) say(used ? '3 picked. One bundle discount per order, and yours is already in your cart.' : '3 picked. Add them to your cart and the $7 comes off.', { ms: 4000 });
  }
  // a photo token flies from the card into its slot (transform only)
  function fly(p) {
    if (REDUCED) return;
    const from = cardOf(p).querySelector('.bb-card__ph').getBoundingClientRect(), to = slotsEl.children[picks.indexOf(p.i)]?.querySelector('.bb-slot')?.getBoundingClientRect();
    if (!to || !from.width) return;
    const t = document.createElement('i');
    t.className = 'bb-fly';
    t.innerHTML = `<img src="${img(photo(p), 360)}" alt="">`;
    t.style.width = t.style.height = to.width + 'px';
    document.body.appendChild(t); // above the sticky header (var(--layer-temporary)), below dialogs
    const s = from.width / to.width, x0 = from.left + from.width / 2 - to.width / 2, y0 = from.top + from.height / 2 - to.height / 2;
    t.animate([{ transform: `translate(${x0}px, ${y0}px) scale(${s})`, opacity: .9 }, { transform: `translate(${(x0 + to.left) / 2}px, ${Math.min(y0, to.top) - 60}px) scale(${(s + 1) / 2})`, opacity: 1, offset: .45 },
      { transform: `translate(${to.left}px, ${to.top}px) scale(1)`, opacity: 1 }], { duration: 620, easing: 'cubic-bezier(.4,0,.2,1)' }).onfinish = () => t.remove();
  }
  // Shiny flips the card over as Home's Shiny card does; the cards are single-faced, so it steps to scaleX(-1) and repaints while edge-on
  const EDGE = 98.78; // ms: cubic-bezier(.3,.6,.25,1) reaches 90deg at 21.47% of 460 ms
  function flip(c, swap) {
    if (REDUCED) return swap();
    // a turning card takes no clicks; the grid sends a click on its li to the part that sat there at rest (measured from the grid: the li lifts)
    const b = grid.getBoundingClientRect();
    c.rest = ['.bb-card__sh', '.bb-opt', '.bb-card__pick'].map(s => c.querySelector(s)).filter(Boolean)
      .map(el => { const r = el.getBoundingClientRect(); return [el, r.left - b.left, r.top - b.top, r.right - b.left, r.bottom - b.top]; });
    c.classList.add('is-turning');
    c.pend = true;
    // the lift goes on the li, as Home lifts the perspective parent; the picked / hover lift is the card's translate property.
    // Both replace (no transform underneath), so they run on the compositor
    const r = 'perspective(1400px) rotateY', lift = c.parentNode.animate([{ transform: 'none' }, { transform: 'translateY(-8px) scale(1.035)', offset: .3 }, { transform: 'none' }], { duration: 460, easing: 'ease-out' });
    const turn = c.animate([{ transform: r + '(0deg)' }, { transform: r + '(90deg)', offset: .5 }, { transform: r + '(90deg) scaleX(-1)', offset: .5 },
      { transform: r + '(180deg) scaleX(-1)' }], { duration: 460, easing: 'cubic-bezier(.3,.6,.25,1)' });
    const edge = () => { if (swap) { c.pend = false; swap(); swap = null; } };
    (function tick() { turn.currentTime == null || turn.currentTime >= EDGE ? edge() : requestAnimationFrame(tick); })();
    // a second Shiny click ends this one at rest first
    // c.rest stays until the next flip: a press during the turn released after it still clicks the li (their common ancestor)
    const done = c.flip = () => { turn.finish(); lift.finish(); edge(); c.classList.remove('is-turning'); c.flip = null; };
    turn.onfinish = () => c.flip === done && done();
  }
  grid.addEventListener('click', e => {
    let t = e.target;
    // the card fills its li, so a click on the li itself came through a turning card: send it to the part that sat there at rest
    const li = t.parentNode === grid ? t : null, tc = li && li.firstElementChild;
    if (tc && tc.rest) {
      const b = grid.getBoundingClientRect(), x = e.clientX - b.left, y = e.clientY - b.top;
      const hit = tc.rest.find(([, l, tp, r, bt]) => x >= l && x < r && y >= tp && y < bt);
      if (!hit) return;
      t = hit[0];
      if (t.matches('.bb-opt')) { tc.flip?.(); const s = t.querySelector('select'); s.focus(); try { s.showPicker(); } catch {} return; }
      t.focus({ preventScroll: true }); // as the mousedown on it would have
    }
    const c = t.closest('.bb-card'); if (!c) return;
    const p = P[+c.dataset.i];
    if (t.closest('.bb-card__sh')) {
      if (t.disabled) return;
      c.flip?.();
      p.sh = p.sh ? 0 : 1;
      paint(p, true);
      renderTray();
      flip(c, () => { paint(p); if (p.sh && (p.s || p.psf?.[p.xv]) && !REDUCED) replay(c, 'is-swept'); });
      return;
    }
    if (t.closest('.bb-card__pick')) toggle(p);
  });
  grid.addEventListener('change', e => { P[+e.target.dataset.i].xv = e.target.value; repaint(); });
  slotsEl.addEventListener('click', e => {
    const b = e.target.closest('button.bb-slot'); if (!b) return;
    const p = P[+b.dataset.i];
    picks.splice(picks.indexOf(p.i), 1);
    if (swapFor != null) hush(); // a pending Swap would take out a second ball
    repaint();
    $('bb-add').focus(); // the slot is gone; the add button is the next stop and says how many are left
  });

  let busy = false; // an add to cart is in flight
  $('bb-add').addEventListener('click', async () => {
    const add = $('bb-add');
    if (busy || add.classList.contains('is-added')) return;
    if (picks.length < 3) return say(`Pick ${plural(3 - picks.length, 'more ball')} to make a bundle.${used ? '' : ' The $7 comes off when there are 3.'}`);
    const ps = picks.map(i => P[i]);
    const items = ps.map(p => ({ id: variant(p)[0], quantity: 1 }));
    const off = used ? 0 : OFF, total = ps.reduce((s, p) => s + variant(p)[3], 0) - off;
    const names = list(ps.map(p => (p.sh ? '✦ ' : '') + p.n)); // as added: Shiny can still change while it adds
    busy = true;
    $('bb-addL').textContent = 'Adding…';
    // the code goes on before the balls, so the cart drawer the add refreshes already shows the $7; a failed add takes it off again.
    // The cart keeps any codes it had (the discount param sets the whole list)
    let c, codes = null;
    if (off) {
      try {
        codes = (await fetch(Theme.routes.cart_url + '.js').then(r => r.json())).discount_codes.map(d => d.code);
        if (!codes.includes(CODE)) await setCodes([...codes, CODE]);
      } catch (err) { console.error(err); codes = null; } // no code: the balls still go in, and the messages below don't promise the $7
    }
    try {
      c = await addToCart(add, items, 'g3d-build-bundle');
    } catch (err) {
      if (codes && !codes.includes(CODE)) setCodes(codes).catch(console.error);
      busy = false;
      renderTray();
      return say("Couldn't add your bundle: " + (err.message || 'please try again').replace(/\.$/, '') + '.', { ms: 8000 });
    }
    busy = false;
    // the cart's own word: a discount there now is the $7 (with any other in the cart before, used was set and off is 0); c null: unknown
    const got = off && c?.total_discount > 0;
    add.classList.add('is-added');
    $('bb-addL').textContent = 'Added to cart ✓';
    $('bb-addS').textContent = money(got ? total : total + off) + (got ? ' after $7 off' : '');
    say(`Added ${names} to your cart.${got ? ' The $7 is off in your cart.' : ''}`, { ok: true, ms: 6000 });
    // the box packs itself (4.4 s, all CSS) and the picks clear once the lid is shut; with reduced motion, or with the box
    // off screen (Add in the sticky tray), all at once
    const quick = REDUCED || box.classList.contains('is-paused');
    if (!quick) replay(box, 'is-packing');
    setTimeout(() => {
      // only the 3 that were added leave; a pick changed while it was adding stays, and waits for the fresh box like a new one
      const keep = picks.filter(i => !ps.some(p => p.i === i));
      picks = [];
      if (c) used = c.total_discount > 0; // the cart as it is now: the fresh box knows whether the $7 is taken
      ps.forEach(p => { p.sh = 0; p.xv = (p.v.find(v => v[4]) || p.v[0])[2]; });
      repaint();
      hold = !quick;
      if (keep.length) { picks = keep; repaint(); }
    }, quick ? 0 : 1300);
    // a fresh box has opened by now; the button resets with it, and picks made meanwhile drop in
    setTimeout(() => { hold = false; add.classList.remove('is-added'); box.classList.remove('is-packing'); renderTray(); }, quick ? 2400 : 4500);
  });

  // filters: search + Region / Group / Type, as on the Pokedex page's toolbar
  const state = { region: -1, group: '', type: '', q: '' }, q = $('bb-q');
  const regionsEl = $('bb-regions'), groupsEl = $('bb-groups'), typesEl = $('bb-types');
  regionsEl.innerHTML = REGIONS.map(([name], ri) => { const n = P.filter(p => p.region === ri).length; return n ? `<button type="button" class="bb-pill" data-r="${ri}">${name}<small>${n}</small></button>` : ''; }).join('');
  groupsEl.innerHTML = GROUPS.map(([id, label]) => `<button type="button" class="bb-pill" data-g="${id}">${label}<small>${P.filter(p => p.inG(id)).length}</small></button>`).join('');
  typesEl.innerHTML = Object.keys(TYPE_C).map(t => { const n = P.filter(p => p.types.includes(t)).length; return n ? `<button type="button" class="bb-pill" data-t="${t}"><i class="bb-dot" style="--c:${TYPE_C[t]}"></i>${t}<small>${n}</small></button>` : ''; }).join('');
  function apply(deal) {
    const words = state.q.toLowerCase().replace(/#|no\.\s*/g, ' ').split(/\s+/).filter(Boolean).map(w => /^\d+$/.test(w) ? String(+w) : w);
    let shown = 0;
    const lis = [];
    P.forEach(p => {
      const ok = (state.region < 0 || p.region === state.region) && (!state.group || p.inG(state.group)) && (!state.type || p.types.includes(state.type))
        && words.every(w => /^\d+$/.test(w) ? p.num === +w : p.hay.includes(w));
      const li = cardOf(p).parentElement;
      li.hidden = !ok;
      if (ok) { shown++; lis.push(li); }
    });
    const on = { region: state.region >= 0 && REGIONS[state.region][0], group: state.group && GROUPS.find(g => g[0] === state.group)[1], type: state.type };
    const filtered = state.region >= 0 || state.group || state.type || words.length;
    $('bb-count').innerHTML = filtered ? `Showing <b>${shown}</b> of ${P.length} balls` : `All <b>${P.length}</b> balls, in dex order`;
    $('bb-clear').hidden = !filtered;
    $('bb-qClear').hidden = !state.q;
    $('bb-empty').hidden = !!shown;
    $('bb-emptyH').textContent = 'No balls match ' + ([state.q && `"${state.q.trim()}"`, on.type, on.group, on.region].filter(Boolean).join(' + ') || 'that');
    regionsEl.querySelectorAll('.bb-pill').forEach(b => b.setAttribute('aria-pressed', +b.dataset.r === state.region));
    groupsEl.querySelectorAll('.bb-pill').forEach(b => b.setAttribute('aria-pressed', b.dataset.g === state.group));
    typesEl.querySelectorAll('.bb-pill').forEach(b => b.setAttribute('aria-pressed', b.dataset.t === state.type));
    root.querySelectorAll('.bb-dd').forEach(dd => {
      const v = on[dd.dataset.k], b = dd.firstElementChild;
      dd.classList.toggle('is-set', !!v);
      b.firstElementChild.classList.toggle('bb-sr', !!v);
      b.children[1].innerHTML = !v ? '' : (dd.dataset.k === 'type' ? `<i class="bb-dot" style="--c:${TYPE_C[v]}"></i>` : '') + v;
      dd.lastElementChild.hidden = !v;
    });
    if (deal && !REDUCED) {
      lis.forEach(li => li.classList.remove('bb-in'));
      void grid.offsetWidth;
      lis.forEach((li, k) => { li.style.setProperty('--d', Math.min(k, 14) * 28 + 'ms'); li.classList.add('bb-in'); });
    }
  }
  const set = patch => { Object.assign(state, patch); apply(true); };
  regionsEl.onclick = e => { const b = e.target.closest('.bb-pill'); if (b) set({ region: state.region === +b.dataset.r ? -1 : +b.dataset.r }); };
  groupsEl.onclick = e => { const b = e.target.closest('.bb-pill'); if (b) set({ group: state.group === b.dataset.g ? '' : b.dataset.g }); };
  typesEl.onclick = e => { const b = e.target.closest('.bb-pill'); if (b) set({ type: state.type === b.dataset.t ? '' : b.dataset.t }); };
  q.oninput = () => { state.q = q.value; apply(false); }; // no deal-in replay per keystroke
  q.onkeydown = e => { if (e.key === 'Escape' && q.value) { e.preventDefault(); e.stopPropagation(); q.value = ''; set({ q: '' }); } };
  $('bb-qClear').onclick = () => { q.value = ''; set({ q: '' }); q.focus(); };
  const clearAll = () => { q.value = ''; set({ region: -1, group: '', type: '', q: '' }); };
  $('bb-clear').onclick = () => { clearAll(); root.querySelector('.bb-dd__btn').focus(); };
  $('bb-emptyClear').onclick = () => { clearAll(); q.focus(); };
  // the dropdowns: one open at a time; a pick, Escape (claimed here, so the theme's cart drawer doesn't close), a click elsewhere or focus leaving closes it
  const dds = $('bb-dds');
  let ddOpen = null;
  function closeDd(focus) {
    if (!ddOpen) return;
    ddOpen.setAttribute('aria-expanded', false);
    ddOpen.nextElementSibling.hidden = true;
    if (focus) ddOpen.focus({ preventScroll: true });
    ddOpen = null;
  }
  dds.addEventListener('focusout', e => { if (ddOpen && e.relatedTarget && !ddOpen.parentElement.contains(e.relatedTarget)) closeDd(); });
  dds.addEventListener('keydown', e => { if (e.key === 'Escape' && ddOpen) { e.preventDefault(); e.stopPropagation(); closeDd(true); } });
  dds.onclick = e => {
    const b = e.target.closest('.bb-dd__btn'), x = e.target.closest('.bb-dd__x');
    if (b) {
      const was = b === ddOpen;
      closeDd();
      if (was) return;
      ddOpen = b;
      b.setAttribute('aria-expanded', true);
      b.nextElementSibling.hidden = false;
      (b.nextElementSibling.querySelector('[aria-pressed=true]') || b.nextElementSibling.firstElementChild).focus();
    }
    if (e.target.closest('.bb-pill')) closeDd(true);
    if (x) { const k = x.parentElement.dataset.k; set({ [k]: k === 'region' ? -1 : '' }); x.parentElement.firstElementChild.focus(); }
  };
  root.addEventListener('pointerdown', e => { if (ddOpen && !ddOpen.parentElement.contains(e.target)) closeDd(); });

  repaint();
  apply(false);
  fetch(Theme.routes.cart_url + '.js').then(r => r.json()).then(c => { used = c.total_discount > 0; renderTray(); }, () => {}); // unread: the tray promises the $7, as before
})();
